'use client';

import { c as _c } from "react/compiler-runtime";
import { useI18n } from '~/features/i18n';
import { cn } from '~/utils';

/**
 * Playful handwritten "try AI search" annotation with a curly, gently bobbing hand-drawn arrow
 * pointing at the AI Search toggle. Purely decorative — positioned by the caller, never
 * intercepts clicks. The arrow bobs toward its tip to draw the eye to the toggle.
 */
export const AiSearchNudge: React.FC<{
  className?: string;
}> = t0 => {
  const $ = _c(12);
  const {
    className
  } = t0;
  const i18n = useI18n();
  let t1;
  if ($[0] !== className) {
    t1 = cn("max-lg:flex-col max-lg:gap-1 pointer-events-none absolute z-10 flex select-none items-center lg:flex-col", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("whitespace-nowrap font-handwriting font-bold leading-none text-yellow-600 [text-shadow:0_1px_6px_rgba(0,0,0,0.25)]", "max-lg:-rotate-3 max-lg:text-base", "lg:-rotate-8 lg:-translate-x-4 lg:translate-y-8 lg:text-3xl");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== i18n) {
    t3 = i18n._("activity.search.ai.tryNudge", undefined, {
      message: "Try AI Search!"
    });
    $[3] = i18n;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <span className={t2}>{t3}</span>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <svg viewBox="0 0 24 24" fill="none" className="size-6 shrink-0 -translate-x-2 translate-y-2 -scale-x-100 text-yellow-600 [filter:drop-shadow(0_1px_4px_rgba(0,0,0,0.2))] lg:hidden"><path d="M23.25 20.242c-0.353 0.018 -1.2 0 -1.554 0A20.925 20.925 0 0 1 0.75 0.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /><path d="m20.25 17.25 3 3 -3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <svg viewBox="0 0 24 24" fill="none" className="rotate-30 mt-6 hidden size-8 -translate-x-4 translate-y-8 scale-x-[1] text-yellow-600 [filter:drop-shadow(0_1px_4px_rgba(0,0,0,0.2))] lg:block"><path d="M23.25 20.242c-0.353 0.018 -1.2 0 -1.554 0A20.925 20.925 0 0 1 0.75 0.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /><path d="m20.25 17.25 3 3 -3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t1 || $[10] !== t4) {
    t7 = <div aria-hidden={true} className={t1}>{t4}{t5}{t6}</div>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};